const CONTAINER = {
  width: {
    xl: "1440px",
    lg: "1087px",
  },
  marginX: {
    lg: 'auto',
    xs: '5%'
  },
};

export default CONTAINER;
